import React from 'react'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import { handleCloneQuote } from 'Utils/functions'
import duplicateBlack from './icons/duplicate-black.svg'

const ModalQuoteCloneAlert = ({
  showModalClone,
  setshowModalClone,
  quote,
  setIsLoadingClone,
  checkFinalPrice,
  history,
  isSearch,
  handlePreCloneQuote,
}) => {
  return (
    <Modal
      open={showModalClone}
      onClose={() => setshowModalClone(false)}
      aria-labelledby="modal-clonar-title"
      aria-describedby="modal-clonar-description"
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
          },
        },
      }}>
      <Box
        className="modal-box"
        style={{
          maxWidth: '450px',
          margin: '20px auto',
          backgroundColor: '#FFFFFF',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          outline: 'none',
          height: 'max-content',
        }}>
        <div
          className="modal-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '20px 20px 15px 20px',
          }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div
              style={{
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <img
                src={duplicateBlack}
                alt="duplicate"
                style={{
                  cursor: 'pointer',
                }}
              />
            </div>
            <h2
              style={{
                margin: 0,
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#333',
              }}>
              Clonar cotización
            </h2>
          </div>
          <button
            onClick={() => setshowModalClone(false)}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: '5px',
              borderRadius: '4px',
              color: '#003082',
              fontSize: '18px',
              fontWeight: 'bold',
            }}>
            ✕
          </button>
        </div>

        <div className="modal-content" style={{ padding: '0 20px' }}>
          <p
            style={{
              margin: '0 0 20px 0',
              fontSize: '16px',
              color: '#333',
              lineHeight: '1.5',
              marginBottom: '30px',
            }}>
            ¿Estás seguro que deseas clonar la cotización número:{' '}
            <strong style={{ fontSize: '18px' }}>
              {quote?.DocumentNumber || quote?.numero}
            </strong>
            ?
          </p>
        </div>

        <div
          className="modal-footer"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '12px',
            padding: '15px 20px 20px 20px',
          }}>
          <button
            onClick={() => setshowModalClone(false)}
            style={{
              backgroundColor: 'transparent',
              color: '#003082',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={e => {
              e.target.style.backgroundColor = '#f0f0f0'
            }}
            onMouseLeave={e => {
              e.target.style.backgroundColor = 'transparent'
            }}>
            Cancelar
          </button>
          <button
            onClick={async () => {
              setshowModalClone(false)
              if (isSearch) {
                await handlePreCloneQuote()
                return
              }
              await handleCloneQuote({
                lines: quote?.Lines,
                setIsLoading: setIsLoadingClone,
                checkFinalPrice,
                customerId: quote?.CustomerId,
                history,
              })
            }}
            style={{
              backgroundColor: '#003082',
              color: '#FFFFFF',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'background-color 0.2s',
            }}>
            Confirmar
          </button>
        </div>
      </Box>
    </Modal>
  )
}

export default ModalQuoteCloneAlert
